import styled from "@emotion/styled"
import { Flex } from "@rebass/grid/emotion"

import { scale, rhythm } from "@utils/typography"

const Icon = styled.div`
  flex: ${props =>
    props.direction && props.direction !== "column" ? "0" : "1 1 auto"};
  ${props =>
    props.direction && props.direction !== "column"
      ? `margin-right: ${rhythm(1)}`
      : `margin-bottom: ${rhythm(1 / 2)}`};
  & > svg {
    height: ${props => (props.lg ? "89px" : "64px")};
    width: auto;
  }
`

const Wrapper = styled(Flex)`
  display: flex;
  flex-direction: ${props => (props.direction ? props.direction : "column")};
  justify-content: ${props =>
    props.direction && props.direction !== "column"
      ? "flex-start"
      : "space-between"};
  padding: ${rhythm(1)} 0;
  text-align: ${props =>
    props.direction && props.direction !== "column" ? "left" : "center"};
`

const Value = styled.strong`
  display: block;
  ${scale(1 / 4)};
  font-weight: 700;
  &:after {
    content: "";
    display: block;
    margin: ${rhythm(1 / 2)}
      ${props =>
        props.direction && props.direction !== "column" ? "0" : "auto"};
    border-bottom: 2px solid
      ${props => (props.colour ? props.colour : props.theme.colours.primary)};
    width: ${props =>
      props.direction && props.direction !== "column" ? "50%" : "80%"};
  }
`

export { Icon, Wrapper, Value }
